import Vue from 'vue';
import App from './App.vue';

// Components
import './components'

// Style
import './assets/common.scss'

// Plugins
import './plugins'
import i18n from '@/plugins/i18n'
// App
import '@/services/app.service'
import './utils/const'
import './services/eventbus'
import './filters/filters'
import './utils/utils'
import router from '@/router'
import store from '@/store/store'

import * as format from "string-format"
format.extend(String.prototype, {})

// Sync router with store
Vue.config.productionTip = false;

window.vueapp = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');


